// extracted by mini-css-extract-plugin
export default {"label":"info-field_label__spFfF","text":"info-field_text__WvAcG"};